import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import pure from "recompose/pure";
import Typography from "@material-ui/core/Typography";
import Tooltip from "./Tooltip";

import { truncate } from "../utils/helpers";

const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  i18nKey,
  referenceResource,
  parentResource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  fullWidth,
  searchKeys,
  pageSize,
  ...rest
}) => rest;

const TextField = ({ className, source, addLabel, record = {}, render, length = 30, ...rest }) => {
  const value =
    typeof render === "function" ? render(record) : get(record, source) === null || get(record, source) === undefined ? "-" : get(record, source);
  return (
    <Typography component="span" className={addLabel ? "" : className} {...sanitizeRestProps(rest)}>
      {value?.length > length ? (
        <Tooltip title={value}>
          <span>{truncate(value, length)}</span>
        </Tooltip>
      ) : (
        value
      )}
    </Typography>
  );
};

TextField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired
};

const PureTextField = pure(TextField);

PureTextField.defaultProps = {
  addLabel: true
};

export default PureTextField;
